// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"84fde313","186":"1d4c1555","225":"cee25b37","272":"54ef8a23","372":"be8c387c","573":"748ad8c3","738":"beed57d3","815":"71ef663e","841":"e78fcc2b","856":"124b475a"}[chunkId] + ".chunk.js";
};